/* eslint-disable */
// @ts-nocheck
import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../../main/support/dash_api';
import NotificationActions from '../../main/actions/NotificationActions';
import type { Settings, UserView } from '../types/userTypes';
// TODO: This is not used. Verify and remove if not needed
const GetUser = new ReduxAsyncAction('GET_USER');
GetUser.registerRequest(function () {
  return dash_api.get('/v1/dashboard-user/by-cookie').then(({ data }) => {
    return data;
  });
});
export const GET_USER = GetUser.constants;
export const loadUser = GetUser.request;
const UpdateUser = new ReduxAsyncAction('UPDATE_USER');
UpdateUser.registerRequest(function (body) {
  return dash_api.patch(`/v1/dashboard-user`, body).then((res) => {
    return res.data;
  });
});
export const UPDATE_USER = UpdateUser.constants;
export const updateUser = UpdateUser.request;
const UpdateSettings = new ReduxAsyncAction('UPDATE_USER_SETTINGS');
UpdateSettings.registerRequest(function (body) {
  return dash_api.patch(`/v1/dashboard-user`, body).then((res) => res.data);
});
export const UPDATE_USER_SETTINGS = UpdateSettings.constants;
export const updateUserSettings =
  (settings: Settings) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(UpdateSettings.request(settings));
      NotificationActions.showNotification('Settings updated', 'success');
    } catch (err) {
      NotificationActions.showNotification('Could no update user settings', 'error');
    }
  };
const GetRole = new ReduxAsyncAction('GET_ROLE');
GetRole.registerRequest(function () {
  return dash_api.get('/v1/dashboard-user/role').then(({ data }) => {
    return {
      access_role_id: data.access_role_id,
    };
  });
});
export const GET_ROLE = GetRole.constants;
export const loadRole = GetRole.request;
const SetUserView = new ReduxAsyncAction('SET_USER_VIEW');
SetUserView.registerRequest(function (view: UserView) {
  return dash_api
    .post('/v1/dashboard-user/set-view', {
      view,
    })
    .then(() => {
      location.reload();
    })
    .catch((err) => {
      NotificationActions.entityError('Error switching view');
    });
});
export const setUserView = SetUserView.request;
export const SET_USER_VIEW = SetUserView.constants;
